import React, { useContext, useState } from "react";

import { useHistory } from "react-router-dom";
import {
  ALL_USERS_QUERY,
  USER_PAGINATION_QUERY
} from "../../../graphql/Users/Users.graphql";

import { ModalContext } from "../../../components/ModalProvider";

import { AddUserForm } from "../../../components/Users";

import DataTable from "../../../components/DataTable";

import { USER_COLUMNS } from "./columns";
import PageHeader from "../../../components/PageHeader";

import UsersFilters from "./UsersFilters";

import { getFilterState, saveFilterState } from "../../../utils";

function UsersPage() {
  const history = useHistory();
  const INITIAL_FILTER_STATE = getFilterState("USER_FILTERS", {
    Active: true
  });
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const { setModalOpen } = useContext(ModalContext);

  const handleSetFilters = inputs => {
    saveFilterState("USER_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () => setFilters({ Active: true });
  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={UsersFilters}
        columns={USER_COLUMNS}
        filters={filters}
        name="Users"
        orderByMulti={["LastName_DESC", "FirstName_DESC"]}
        query={ALL_USERS_QUERY}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Users"
        onAddClick={() =>
          setModalOpen(
            true,
            <AddUserForm onComplete={() => setModalOpen(false, "")} />
          )
        }
      />
      <DataTable
        columns={USER_COLUMNS}
        dataQuery={ALL_USERS_QUERY}
        initialSortBy={[
          { id: "LastName", desc: false },
          { id: "FirstName", desc: false }
        ]}
        name="User"
        paginationQuery={USER_PAGINATION_QUERY}
        where={filters}
        onRowClick={({ RecId }) =>
          history.push(`/admin/users/${RecId}/details`)
        }
      />
    </React.Fragment>
  );
}

UsersPage.propTypes = {};

export default UsersPage;
